// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.app-header {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 0;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  height: 80px;
  display: flex;
  align-items: center;
}

.header-content {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

.header-content h1 {
  color: white;
  margin: 0;
  font-size: 1.8rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.dashboard-container {
  padding: 2rem 1rem;
  animation: fadeSlideUp 0.3s ease-out;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.dashboard-content {
  max-width: 1600px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  width: 100%;
  box-sizing: border-box;
}

/* Modern search input styling (if not already styled in StaffLookup component) */
.search-input {
  width: 100%;
  padding: 0.8rem 1rem;
  font-size: 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background-color: white;
  transition: all 0.2s ease;
  margin-bottom: 1.5rem;
}

.search-input:focus {
  outline: none;
  border-color: #2a5298;
  box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.1);
}

/* Enhanced responsive design */
@media (max-width: 768px) {
  .app-header {
    height: auto;
    padding: 15px 0;
  }

  .header-content {
    flex-direction: column;
    gap: 15px;
    text-align: center;
    padding: 0 20px;
  }

  .header-content h1 {
    font-size: 1.5rem;
  }

  .nav-links {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;
  }

  .environment-indicator,
  .user-role,
  .logout-btn {
    margin: 5px;
    padding: 6px 12px;
  }

  .dashboard-container {
    padding: 1rem 0.5rem;
  }

  .dashboard-content {
    padding: 1rem;
    border-radius: var(--radius-md);
  }

  .search-input {
    padding: 0.6rem 0.8rem;
    font-size: 0.9rem;
  }

  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  th, td {
    padding: 8px;
    font-size: 0.9rem;
  }

  .tab-menu-content {
    padding: 0 16px;
  }

  .tab-menu {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  .tab-menu::-webkit-scrollbar {
    display: none;
  }

  .tab-button {
    padding: 12px 16px;
    font-size: 0.9rem;
    white-space: nowrap;
  }
}

@media (max-width: 480px) {
  .app-header h1 {
    font-size: 1.1rem;
  }

  .dashboard-content {
    padding: 0.5rem;
  }
}

.search-container {
  margin: 20px 0;
  display: flex;
  gap: 10px;
}

.search-container input {
  padding: 8px;
  width: 300px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-btn, .check-license-btn {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.search-btn:hover, .check-license-btn:hover {
  background-color: #0056b3;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f8f9fa;
}

.status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.9em;
}

.status.valid {
  background-color: #d4edda;
  color: #155724;
}

.status.expired {
  background-color: #f8d7da;
  color: #721c24;
}

.status.pending {
  background-color: #fff3cd;
  color: #856404;
}

:root {
  --primary-color: #2196f3;
  --primary-dark: #1976d2;
  --success-color: #2ecc71;
  --warning-color: #f1c40f;
  --danger-color: #e74c3c;
  --text-primary: #2c3e50;
  --text-secondary: #7f8c8d;
  --background-light: #f8f9fa;
  --border-color: #e0e0e0;
  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);
  --shadow-md: 0 4px 6px rgba(0,0,0,0.1);
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
}

.tab-navigation {
  background-color: white;
  border-bottom: 1px solid #dee2e6;
  padding: 0 2rem;
}

.tab-navigation-content {
  max-width: 1200px;
  margin: 0 auto;
}

.tab-button {
  padding: 1rem 1.5rem;
  margin-right: 1rem;
  border: none;
  background: none;
  font-size: 1rem;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #495057;
}

.tab-button:hover {
  color: #007bff;
}

.tab-button.active {
  border-bottom: 2px solid #007bff;
  color: #007bff;
}

.settings-container {
  padding: 2rem;
}

.settings-content {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 2rem;
}

.settings-content h2 {
  color: var(--text-primary);
  margin-bottom: 2rem;
  font-size: 1.75rem;
  font-weight: 600;
}

.settings-grid {
  display: grid;
  gap: 1.5rem;
  max-width: 800px;
  margin: 0 auto;
}

.setting-item {
  background: var(--background-light);
  padding: 1.5rem;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  transition: all 0.2s ease;
}

.setting-item:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.setting-item label {
  display: block;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.setting-item span {
  color: var(--text-secondary);
  font-size: 0.95rem;
}

.setting-item select,
.setting-item textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background-color: white;
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

.setting-item select:hover,
.setting-item textarea:hover {
  border-color: #2a5298;
}

.setting-item select:focus,
.setting-item textarea:focus {
  outline: none;
  border-color: #2a5298;
  box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.1);
}

.setting-item textarea {
  min-height: 100px;
  resize: vertical;
}

@media (max-width: 768px) {
  .settings-content {
    padding: 1.5rem;
  }
  
  .settings-content h2 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .setting-item {
    padding: 1rem;
  }
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 20px;
  height: 100%;
}

.environment-indicator {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 8px;
  margin-right: 15px;
  font-size: 0.95em;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(5px);
  transition: all 0.2s ease;
}

.environment-indicator:hover {
  background: rgba(255, 255, 255, 0.15);
}

.environment-indicator span {
  margin-left: 8px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
  letter-spacing: 0.5px;
}

.environment-indicator span.test {
  background-color: rgba(33, 150, 243, 0.3);
  color: #90caf9;
  border: 1px solid rgba(144, 202, 249, 0.3);
}

.environment-indicator span.live {
  background-color: rgba(244, 67, 54, 0.3);
  color: #ffcdd2;
  border: 1px solid rgba(255, 205, 210, 0.3);
}

.user-role {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.95em;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(5px);
  transition: all 0.2s ease;
}

.user-role:hover {
  background: rgba(255, 255, 255, 0.15);
}

.logout-btn {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 8px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95em;
  font-weight: 500;
  transition: all 0.2s ease;
  backdrop-filter: blur(5px);
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.logout-btn:active {
  transform: translateY(0);
}

.tab-menu {
  background: white;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid var(--border-color);
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.tab-menu-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 28px;
}

.tab-button {
  padding: 16px 24px;
  margin: 0;
  border: none;
  background: none;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-secondary);
  position: relative;
  transition: all 0.3s ease;
  cursor: pointer;
}

.tab-button::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  transition: all 0.3s ease;
  transform: translateX(-50%);
  border-radius: 3px 3px 0 0;
}

.tab-button:hover {
  color: #1e3c72;
}

.tab-button.active {
  color: #1e3c72;
  font-weight: 600;
  background: transparent;
  border: none;
}

.tab-button.active::after {
  width: 100%;
}

@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.settings-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin: 20px;
}

.email-settings {
  margin-top: 15px;
}

.email-settings ul {
  list-style: none;
  padding: 0;
}

.email-settings li {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.primary-email-tag {
  background: #e3f2fd;
  color: #1976d2;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 10px;
}

.remove-email-btn {
  margin-left: auto;
  padding: 4px 8px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.remove-email-btn:hover {
  background: #d32f2f;
}

.email-settings form {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

.email-settings input[type="email"] {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.email-settings button[type="submit"] {
  padding: 8px 16px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.email-settings button[type="submit"]:hover {
  background: #43a047;
}

.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-size: 1.2rem;
    color: #666;
}

.error-message {
    color: #ff0000;
    text-align: center;
    padding: 1rem;
    margin: 1rem 0;
    background-color: #ffe6e6;
    border-radius: 4px;
}

.email-edit-container {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.email-input {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.save-btn, .cancel-btn, .edit-btn {
  padding: 4px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.save-btn {
  background-color: #4CAF50;
  color: white;
}

.cancel-btn {
  background-color: #f44336;
  color: white;
}

.edit-btn {
  background-color: #f8f9fa;
  color: #2c3e50;
  border: 1px solid #e0e0e0;
  margin-left: 8px;
  transition: all 0.2s ease;
}

.edit-btn:hover {
  background-color: #e9ecef;
  border-color: #ced4da;
  color: #2c3e50;
  transform: none;
  box-shadow: none;
}

.edit-btn::after {
  display: none;
}

.error-message {
  color: #f44336;
  font-size: 0.875rem;
  margin-top: 4px;
  width: 100%;
}

.email-display {
  display: flex;
  align-items: center;
}

/* Add these to your existing App.css */
.dashboard-container.live {
  position: relative;
}

.live-mode-banner {
  background-color: #fff3cd;
  color: #856404;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ffeeba;
  border-radius: 4px;
  text-align: center;
  font-weight: bold;
}

/* Different background tints for test/live modes */
.dashboard-container.test {
  background-color: #f8f9fa;
}

.dashboard-container.live {
  background-color: #fff3cd20;
}

/* Adjust table container width */
.staff-table-container {
  width: 90%;
}

/* Ensure table takes full width of its container */
.staff-table {
  width: 90%;
  table-layout: fixed;
}

/* Adjust specific column widths */
.staff-table th,
.staff-table td {
  padding: 12px 8px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Define specific column widths for better distribution */
.name-cell {
  width: 12%;  /* Decreased from 15% */
}

.license-number-cell {
  width: 12%;
}

.status-cell {
  width: 10%;
}

.points-cell {
  width: 8%;
}

.date-cell {
  width: 10%;
}

.expiry-cell {
  width: 10%;
}

.actions-cell {
  width: 10%;  /* Decreased from 12% */
}

/* Add these styles to your App.css */
.credits-info {
  margin-top: 20px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}

.credits-details {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.credits-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.credits-label {
  font-weight: 500;
  color: #64748b;
}

.credits-value {
  font-size: 1.1rem;
  font-weight: 600;
  color: #334155;
  padding: 4px 12px;
  background: white;
  border-radius: 6px;
  min-width: 80px;
  text-align: center;
}

.credits-value.available {
  background-color: #e3f2fd;
  color: #1976d2;
}

.credits-value.total {
  background-color: #f5f5f5;
  color: #424242;
}

.credits-value.used {
  background-color: #fce4ec;
  color: #c2185b;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .credits-stat {
    padding: 8px 12px;
  }

  .credits-value {
    font-size: 1em;
    padding: 3px 10px;
  }
}

/* Add a more specific rule to ensure edit button styling */
.email-display .edit-btn {
  background-color: #f8f9fa;
  color: #2c3e50;
  border: 1px solid #e0e0e0;
  margin-left: 8px;
  transition: all 0.2s ease;
  position: relative;
  background-image: none;
}

.email-display .edit-btn:hover {
  background-color: #e9ecef;
  border-color: #ced4da;
  color: #2c3e50;
  transform: none;
  box-shadow: none;
  background-image: none;
}

.email-display .edit-btn::after {
  display: none;
  content: none;
  width: 0;
  height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,iDAAiD;EACjD,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,+BAA+B;AAC/B;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,SAAS;EACX;;EAEA;;;IAGE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,uCAAuC;EACvC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,+BAA+B;EAC/B,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,4CAA4C;EAC5C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;;EAEE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,UAAU,GAAG,uBAAuB;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU,GAAG,uBAAuB;AACtC;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,QAAQ;EACR,SAAS;AACX","sourcesContent":[".App {\n  min-height: 100vh;\n  background-color: #f5f7fa;\n}\n\n.app-header {\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 20px 0;\n  box-shadow: 0 3px 6px rgba(0,0,0,0.16);\n  height: 80px;\n  display: flex;\n  align-items: center;\n}\n\n.header-content {\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 0 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.header-content h1 {\n  color: white;\n  margin: 0;\n  font-size: 1.8rem;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.1);\n}\n\n.dashboard-container {\n  padding: 2rem 1rem;\n  animation: fadeSlideUp 0.3s ease-out;\n  max-width: 1600px;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.dashboard-content {\n  max-width: 1600px;\n  margin: 0 auto;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  padding: 1.5rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Modern search input styling (if not already styled in StaffLookup component) */\n.search-input {\n  width: 100%;\n  padding: 0.8rem 1rem;\n  font-size: 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  background-color: white;\n  transition: all 0.2s ease;\n  margin-bottom: 1.5rem;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #2a5298;\n  box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.1);\n}\n\n/* Enhanced responsive design */\n@media (max-width: 768px) {\n  .app-header {\n    height: auto;\n    padding: 15px 0;\n  }\n\n  .header-content {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n    padding: 0 20px;\n  }\n\n  .header-content h1 {\n    font-size: 1.5rem;\n  }\n\n  .nav-links {\n    width: 100%;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .environment-indicator,\n  .user-role,\n  .logout-btn {\n    margin: 5px;\n    padding: 6px 12px;\n  }\n\n  .dashboard-container {\n    padding: 1rem 0.5rem;\n  }\n\n  .dashboard-content {\n    padding: 1rem;\n    border-radius: var(--radius-md);\n  }\n\n  .search-input {\n    padding: 0.6rem 0.8rem;\n    font-size: 0.9rem;\n  }\n\n  table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n\n  th, td {\n    padding: 8px;\n    font-size: 0.9rem;\n  }\n\n  .tab-menu-content {\n    padding: 0 16px;\n  }\n\n  .tab-menu {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n\n  .tab-menu::-webkit-scrollbar {\n    display: none;\n  }\n\n  .tab-button {\n    padding: 12px 16px;\n    font-size: 0.9rem;\n    white-space: nowrap;\n  }\n}\n\n@media (max-width: 480px) {\n  .app-header h1 {\n    font-size: 1.1rem;\n  }\n\n  .dashboard-content {\n    padding: 0.5rem;\n  }\n}\n\n.search-container {\n  margin: 20px 0;\n  display: flex;\n  gap: 10px;\n}\n\n.search-container input {\n  padding: 8px;\n  width: 300px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.search-btn, .check-license-btn {\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.search-btn:hover, .check-license-btn:hover {\n  background-color: #0056b3;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\nth, td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\nth {\n  background-color: #f8f9fa;\n}\n\n.status {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.9em;\n}\n\n.status.valid {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status.expired {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.status.pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n:root {\n  --primary-color: #2196f3;\n  --primary-dark: #1976d2;\n  --success-color: #2ecc71;\n  --warning-color: #f1c40f;\n  --danger-color: #e74c3c;\n  --text-primary: #2c3e50;\n  --text-secondary: #7f8c8d;\n  --background-light: #f8f9fa;\n  --border-color: #e0e0e0;\n  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);\n  --shadow-md: 0 4px 6px rgba(0,0,0,0.1);\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n}\n\n.tab-navigation {\n  background-color: white;\n  border-bottom: 1px solid #dee2e6;\n  padding: 0 2rem;\n}\n\n.tab-navigation-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.tab-button {\n  padding: 1rem 1.5rem;\n  margin-right: 1rem;\n  border: none;\n  background: none;\n  font-size: 1rem;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  color: #495057;\n}\n\n.tab-button:hover {\n  color: #007bff;\n}\n\n.tab-button.active {\n  border-bottom: 2px solid #007bff;\n  color: #007bff;\n}\n\n.settings-container {\n  padding: 2rem;\n}\n\n.settings-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  padding: 2rem;\n}\n\n.settings-content h2 {\n  color: var(--text-primary);\n  margin-bottom: 2rem;\n  font-size: 1.75rem;\n  font-weight: 600;\n}\n\n.settings-grid {\n  display: grid;\n  gap: 1.5rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.setting-item {\n  background: var(--background-light);\n  padding: 1.5rem;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  transition: all 0.2s ease;\n}\n\n.setting-item:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.setting-item label {\n  display: block;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.setting-item span {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n}\n\n.setting-item select,\n.setting-item textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background-color: white;\n  font-size: 0.95rem;\n  transition: all 0.2s ease;\n}\n\n.setting-item select:hover,\n.setting-item textarea:hover {\n  border-color: #2a5298;\n}\n\n.setting-item select:focus,\n.setting-item textarea:focus {\n  outline: none;\n  border-color: #2a5298;\n  box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.1);\n}\n\n.setting-item textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n@media (max-width: 768px) {\n  .settings-content {\n    padding: 1.5rem;\n  }\n  \n  .settings-content h2 {\n    font-size: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .setting-item {\n    padding: 1rem;\n  }\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  height: 100%;\n}\n\n.environment-indicator {\n  background: rgba(255, 255, 255, 0.12);\n  color: white;\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n  border-radius: 8px;\n  margin-right: 15px;\n  font-size: 0.95em;\n  font-weight: 500;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(5px);\n  transition: all 0.2s ease;\n}\n\n.environment-indicator:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.environment-indicator span {\n  margin-left: 8px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 6px;\n  letter-spacing: 0.5px;\n}\n\n.environment-indicator span.test {\n  background-color: rgba(33, 150, 243, 0.3);\n  color: #90caf9;\n  border: 1px solid rgba(144, 202, 249, 0.3);\n}\n\n.environment-indicator span.live {\n  background-color: rgba(244, 67, 54, 0.3);\n  color: #ffcdd2;\n  border: 1px solid rgba(255, 205, 210, 0.3);\n}\n\n.user-role {\n  background: rgba(255, 255, 255, 0.12);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 0.95em;\n  font-weight: 500;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(5px);\n  transition: all 0.2s ease;\n}\n\n.user-role:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.logout-btn {\n  background: rgba(255, 255, 255, 0.12);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 8px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.95em;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(5px);\n}\n\n.logout-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.logout-btn:active {\n  transform: translateY(0);\n}\n\n.tab-menu {\n  background: white;\n  padding: 0;\n  margin: 0;\n  border-bottom: 1px solid var(--border-color);\n  position: relative;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.tab-menu-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 28px;\n}\n\n.tab-button {\n  padding: 16px 24px;\n  margin: 0;\n  border: none;\n  background: none;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  position: relative;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.tab-button::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  width: 0;\n  height: 3px;\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n  transition: all 0.3s ease;\n  transform: translateX(-50%);\n  border-radius: 3px 3px 0 0;\n}\n\n.tab-button:hover {\n  color: #1e3c72;\n}\n\n.tab-button.active {\n  color: #1e3c72;\n  font-weight: 600;\n  background: transparent;\n  border: none;\n}\n\n.tab-button.active::after {\n  width: 100%;\n}\n\n@keyframes fadeSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.settings-section {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin: 20px;\n}\n\n.email-settings {\n  margin-top: 15px;\n}\n\n.email-settings ul {\n  list-style: none;\n  padding: 0;\n}\n\n.email-settings li {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.primary-email-tag {\n  background: #e3f2fd;\n  color: #1976d2;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  margin-left: 10px;\n}\n\n.remove-email-btn {\n  margin-left: auto;\n  padding: 4px 8px;\n  background: #f44336;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.remove-email-btn:hover {\n  background: #d32f2f;\n}\n\n.email-settings form {\n  margin-top: 15px;\n  display: flex;\n  gap: 10px;\n}\n\n.email-settings input[type=\"email\"] {\n  flex: 1;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.email-settings button[type=\"submit\"] {\n  padding: 8px 16px;\n  background: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.email-settings button[type=\"submit\"]:hover {\n  background: #43a047;\n}\n\n.loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    font-size: 1.2rem;\n    color: #666;\n}\n\n.error-message {\n    color: #ff0000;\n    text-align: center;\n    padding: 1rem;\n    margin: 1rem 0;\n    background-color: #ffe6e6;\n    border-radius: 4px;\n}\n\n.email-edit-container {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.email-input {\n  padding: 4px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.save-btn, .cancel-btn, .edit-btn {\n  padding: 4px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.save-btn {\n  background-color: #4CAF50;\n  color: white;\n}\n\n.cancel-btn {\n  background-color: #f44336;\n  color: white;\n}\n\n.edit-btn {\n  background-color: #f8f9fa;\n  color: #2c3e50;\n  border: 1px solid #e0e0e0;\n  margin-left: 8px;\n  transition: all 0.2s ease;\n}\n\n.edit-btn:hover {\n  background-color: #e9ecef;\n  border-color: #ced4da;\n  color: #2c3e50;\n  transform: none;\n  box-shadow: none;\n}\n\n.edit-btn::after {\n  display: none;\n}\n\n.error-message {\n  color: #f44336;\n  font-size: 0.875rem;\n  margin-top: 4px;\n  width: 100%;\n}\n\n.email-display {\n  display: flex;\n  align-items: center;\n}\n\n/* Add these to your existing App.css */\n.dashboard-container.live {\n  position: relative;\n}\n\n.live-mode-banner {\n  background-color: #fff3cd;\n  color: #856404;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 1px solid #ffeeba;\n  border-radius: 4px;\n  text-align: center;\n  font-weight: bold;\n}\n\n/* Different background tints for test/live modes */\n.dashboard-container.test {\n  background-color: #f8f9fa;\n}\n\n.dashboard-container.live {\n  background-color: #fff3cd20;\n}\n\n/* Adjust table container width */\n.staff-table-container {\n  width: 90%;\n}\n\n/* Ensure table takes full width of its container */\n.staff-table {\n  width: 90%;\n  table-layout: fixed;\n}\n\n/* Adjust specific column widths */\n.staff-table th,\n.staff-table td {\n  padding: 12px 8px;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n/* Define specific column widths for better distribution */\n.name-cell {\n  width: 12%;  /* Decreased from 15% */\n}\n\n.license-number-cell {\n  width: 12%;\n}\n\n.status-cell {\n  width: 10%;\n}\n\n.points-cell {\n  width: 8%;\n}\n\n.date-cell {\n  width: 10%;\n}\n\n.expiry-cell {\n  width: 10%;\n}\n\n.actions-cell {\n  width: 10%;  /* Decreased from 12% */\n}\n\n/* Add these styles to your App.css */\n.credits-info {\n  margin-top: 20px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 10px;\n  border: 1px solid #e0e0e0;\n}\n\n.credits-details {\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.credits-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.credits-label {\n  font-weight: 500;\n  color: #64748b;\n}\n\n.credits-value {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #334155;\n  padding: 4px 12px;\n  background: white;\n  border-radius: 6px;\n  min-width: 80px;\n  text-align: center;\n}\n\n.credits-value.available {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.credits-value.total {\n  background-color: #f5f5f5;\n  color: #424242;\n}\n\n.credits-value.used {\n  background-color: #fce4ec;\n  color: #c2185b;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .credits-stat {\n    padding: 8px 12px;\n  }\n\n  .credits-value {\n    font-size: 1em;\n    padding: 3px 10px;\n  }\n}\n\n/* Add a more specific rule to ensure edit button styling */\n.email-display .edit-btn {\n  background-color: #f8f9fa;\n  color: #2c3e50;\n  border: 1px solid #e0e0e0;\n  margin-left: 8px;\n  transition: all 0.2s ease;\n  position: relative;\n  background-image: none;\n}\n\n.email-display .edit-btn:hover {\n  background-color: #e9ecef;\n  border-color: #ced4da;\n  color: #2c3e50;\n  transform: none;\n  box-shadow: none;\n  background-image: none;\n}\n\n.email-display .edit-btn::after {\n  display: none;\n  content: none;\n  width: 0;\n  height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
